import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorAprBoost = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M18.213 8.307a.748.748 0 0 0-.243.163l-2 2a.75.75 0 1 0 1.06 1.06l.72-.72v4.69a.75.75 0 0 0 1.5 0v-4.69l.72.72a.75.75 0 1 0 1.06-1.06l-2-2a.748.748 0 0 0-.817-.163Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M4.25 12a7.25 7.25 0 0 1 11.78-5.66.75.75 0 1 0 .94-1.17 8.75 8.75 0 1 0 2.11 11.206.75.75 0 1 0-1.3-.751A7.25 7.25 0 0 1 4.25 12Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m11.524 8.21-.044-.332-.017.184a4.387 4.387 0 0 1-4.147 3.98l.379.068a4.632 4.632 0 0 1 3.785 4.096 4.967 4.967 0 0 1 4.006-4.135l.159-.03a4.41 4.41 0 0 1-4.121-3.832Z"
    />
    <path
      fill="#F7A600"
      d="m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
  </svg>
);
export default SvgTwoColorAprBoost;
